import './index.erb';
import './index.rb';
import './index.scss';
import 'images/questions/comments.svg';

$(function () {
  $('#js-questions-review-instructions-modal').modal({ show: true });
});
